import Lockr from 'lockr';

export let getJSON = (key) => {
    return Lockr.get(key);
};

export let set = (key, value) => {
    return Lockr.set(key, value);
};
